import React from 'react';
import { Link } from 'react-router-dom';
import HeaderStyleThree from '../components/Layout/Header/HeaderStyleThree';
import Footer from '../components/Layout/Footer';

const NoPage = () => {
    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <section style={{
                minHeight: '80vh', display: 'flex', alignItems: 'center',
                justifyContent: 'center', textAlign: 'center', padding: '120px 20px 80px',
                background: 'var(--eventflow-black)', position: 'relative'
            }}>
                <div style={{position:'relative', zIndex:1}}>
                    <div style={{
                        fontFamily:'Courier New,monospace', fontSize:'120px', fontWeight:900,
                        background:'linear-gradient(135deg,var(--eventflow-base) 0%,#ff4d9e 100%)',
                        WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent',
                        lineHeight:1, marginBottom:'16px'
                    }}>404</div>
                    <h2 style={{fontFamily:'var(--eventflow-font)',fontSize:'28px',fontWeight:800,color:'#fff',marginBottom:'12px'}}>
                        Page Not Found
                    </h2>
                    <p style={{fontFamily:'var(--eventflow-font)',fontSize:'15px',color:'rgba(255,255,255,0.45)',marginBottom:'32px',maxWidth:'400px'}}>
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Link to="/" className="thm-btn">
                        Back to Home <span className="icon-arrow-right" />
                    </Link>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default NoPage;
